module.exports = __webpack_public_path__ + "media/images/cleaning/cover-mobile-acbc43f0e9e9cf7bf1e783eebe74ab07.jpg";